module.exports = __webpack_public_path__ + "static/media/bg.ec2ca690.png";


//////////////////
// WEBPACK FOOTER
// ./src/inviteNewUsers/share/images/bg.png
// module id = 1150
// module chunks = 0